module.exports = __webpack_public_path__ + "poster10.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster10.png
// module id = 1140
// module chunks = 10